// extracted by mini-css-extract-plugin
export var numpadContainer = "_r8-1";
export var phoneButton = "_r8-0";